import component from './VimeoPost';
import handles from './handles';

export default {
  component,
  handles,
};



// WEBPACK FOOTER //
// ./src/components/VimeoPost/index.js